import React from 'react';
import { Box, Typography, Grid, Paper, Container } from '@mui/material';
import { motion } from 'framer-motion';
import '../assets/fonts/fonts.css';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import MapIcon from '@mui/icons-material/Map';

const services = [
  {
    icon: <DirectionsCarIcon sx={{ fontSize: 40 }} />,
    title: 'Transports privés',
    description: 'Véhicule confortable à votre disposition'
  },
  {
    icon: <FlightTakeoffIcon sx={{ fontSize: 40 }} />,
    title: 'Transferts aéroports',
    description: 'Service direct vers les principaux aéroports'
  },
  {
    icon: <MapIcon sx={{ fontSize: 40 }} />,
    title: 'Tours guidés',
    description: 'Découverte du Luberon en tout confort'
  }
];

const Services = () => {
  return (
    <Box id="services" sx={{ py: 8, bgcolor: '#f5f0e5' }}>
      <Container maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom sx={{ letterSpacing: '0.5px', fontFamily: '"Satisfy", cursive' }}>
          Nos Services
        </Typography>
        
        <Grid container spacing={4} justifyContent="center" alignItems="stretch" sx={{ mt: 4 }}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.2 }}
                  style={{ width: '280px', maxWidth: '100%' }} // Largeur fixe pour tous les services
                >
                  <Paper
                    elevation={2}
                    sx={{
                      p: 4,
                      height: '250px', // Hauteur fixe pour tous les services
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'transform 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-5px)',
                      },
                      width: '100%',
                    }}
                  >
                    {service.icon}
                    <Typography 
                      variant="h5" 
                      component="h3" 
                      gutterBottom 
                      sx={{ 
                        mt: 2,
                        textAlign: 'center',
                        fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
                        wordBreak: 'break-word',
                        hyphens: 'auto',
                        fontFamily: '"Satisfy", cursive'
                      }}
                    >
                      {service.title}
                    </Typography>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: 'text.secondary', 
                        textAlign: 'center',
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                      }}
                    >
                      {service.description}
                    </Typography>
                  </Paper>
                </motion.div>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
